// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".min." + "e4cfbec376cab6a0da93" + ".js";
};